import { normalizeId } from 'utils/ids';

/**
 * Resolve the property a `DataNodeUpdated` / `DataNodeCreated` payload describes for one view.
 *
 * The backend splits a node's Neo4j properties in two: `Properties` is the complete live bag, while
 * `Proposals[proposalId]` holds only the keys that proposal overrides (`ToDataNodeUpdatedPayload` in
 * `DataApi.Core`). A proposal view is therefore the live properties with the overrides layered on top —
 * taking the overrides alone would drop every property the proposal never touched.
 */
export function selectNodeEventProperties(
  properties: Record<string, unknown> | undefined,
  proposals: Record<string, Record<string, unknown>> | undefined | null,
  proposalId: string | undefined
): Record<string, unknown> {
  const liveProperties = properties ?? {};
  if (!proposalId) return liveProperties;

  // Proposal GUIDs differ in casing between the route and the payload, so match them normalized.
  const normalizedProposalId = normalizeId(proposalId);
  const overrides = Object.entries(proposals ?? {}).find(([key]) => normalizeId(key) === normalizedProposalId)?.[1];

  return overrides ? { ...liveProperties, ...overrides } : liveProperties;
}
